class TechIcon {
  constructor(iconClass, description) {
    this.iconClass = iconClass;
    this.description = description;
  }
}

const aws = new TechIcon(
  "devicon-amazonwebservices-plain",
  "Amazon Web Services",
);

const bootstrap = new TechIcon("devicon-bootstrap-plain", "Bootstrap");

const bash = new TechIcon("devicon-bash-plain", "Bash");

const canva = new TechIcon("devicon-canva-original", "Canva");

const css3 = new TechIcon("devicon-css3-plain", "CSS3");

const django = new TechIcon("devicon-django-plain", "Django");

const docker = new TechIcon("devicon-docker-plain", "Docker");

const dotNet = new TechIcon("devicon-dot-net-plain", ".Net");

const electron = new TechIcon("devicon-electron-original", "Electron");

const firebase = new TechIcon("devicon-firebase-plain", "Firebase");

const flask = new TechIcon("devicon-flask-original", "Flask");

const git = new TechIcon("devicon-git-plain", "Git");

const github = new TechIcon("devicon-github-original ", "Github");

const gitlab = new TechIcon("devicon-gitlab-plain", "Gitlab");

const heroku = new TechIcon("devicon-heroku-original", "Heroku");

const html5 = new TechIcon("devicon-html5-plain", "Html5");

const java = new TechIcon("devicon-java-plain", "Java");

const javascript = new TechIcon("devicon-javascript-plain", "Javascript");

const jira = new TechIcon("devicon-jira-plain", "Jira");

const kotlin = new TechIcon("devicon-kotlin-plain", "Kotlin");

const mongo = new TechIcon("devicon-mongodb-plain", "MongoDB");

const mysql = new TechIcon("devicon-mysql-plain", "MySQL");

const node = new TechIcon("devicon-nodejs-plain", "NodeJS");

const npm = new TechIcon("devicon-npm-original-wordmark", "NPM");

const postgres = new TechIcon("devicon-postgresql-plain", "PostgreSQL");

const python = new TechIcon("devicon-python-plain", "Python");

const react = new TechIcon("devicon-react-original", "React");

const ruby = new TechIcon("devicon-ruby-plain", "Ruby");

const selenium = new TechIcon("devicon-selenium-original", "Selenium");

const spring = new TechIcon("devicon-spring-plain", "Spring");

const sqlite = new TechIcon("devicon-sqlite-plain", "SQLite");

const ts = new TechIcon("devicon-typescript-plain", "TypeScript");

const ubuntu = new TechIcon("devicon-ubuntu-plain", "Ubuntu");

const vsCode = new TechIcon("devicon-vscode-plain", "VS Code");

const vue = new TechIcon("devicon-vuejs-plain", "Vue.js");

const techStack = [
  aws,
  bootstrap,
  bash,
  canva,
  css3,
  django,
  docker,
  dotNet,
  electron,
  firebase,
  flask,
  git,
  github,
  gitlab,
  heroku,
  html5,
  java,
  javascript,
  jira,
  kotlin,
  mongo,
  mysql,
  node,
  npm,
  postgres,
  python,
  react,
  ruby,
  selenium,
  spring,
  sqlite,
  ts,
  ubuntu,
  vsCode,
  vue,
];

export default techStack;
